import axios from "axios";

const RESOURCE_URL_V2 = process.env.REACT_APP_API_URL_V2 + "/admin/campus/";

export class InvoiceService {
    config = (sessionToken: string | null, sendFiles: boolean = false) => {
        return {
            headers:
            {
                "Content-Type": sendFiles ? "multipart/form-data" : "application/json",
                Authorization: `Bearer ${sessionToken}`
            }
        };
    }

    isValidString = (value: string | null | undefined): boolean => {
        return typeof value === "string" && value.trim() !== "";
    }

    getPaginatedInvoices = async (sessionToken: string | null, uri: string) => {
        let response = await axios.get(uri, this.config(sessionToken));
        return response;
    }

    getInvoiceByCampusId = async (sessionToken: string | null, campusId: number, perPage: number, criteria?: any, page?: number) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/invoices?perPage=${perPage}`;
		if (page && page > 1) { uri = `${uri}&page=${page}`; }   // página recordada (utils/paginaRecordada)
        if (criteria && typeof criteria === 'object' && Object.keys(criteria).length > 0) {
            try {
                const criteriaJson = JSON.stringify(criteria);
                uri = `${uri}&criteria=${encodeURIComponent(criteriaJson)}`;
            } catch (error) {
                console.error("Error serializando criteria as JSON:", error);
                throw new Error("Invalid criteria format");
            }
        }
        const response = await axios.get(uri, this.config(sessionToken));
        return response;
    }

    getInvoiceById = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_details`;
        let response = await axios.get(uri, this.config(sessionToken));
        return response;
    }

    generateInvoice = async (sessionToken: string | null, campusId: number, studentId: number, payload: any) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/_generatePaidInvoice`;
        let response = await axios.post(uri, payload, this.config(sessionToken));
        return response;
    }

    updateInvoice = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number, payload: any) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}`;
        let response = await axios.put(uri, payload, this.config(sessionToken));
        return response;
    }

    // Notas de la factura en bitácora (Esteban, 2026-09-17): la original no se edita, lo demás se agrega.
    getInvoiceNotes = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_notes`;
        return await axios.get(uri, this.config(sessionToken));
    }

    addInvoiceNote = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number, note: string) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_notes`;
        return await axios.post(uri, { note }, this.config(sessionToken));
    }

    updateInvoiceNote = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number, noteId: number, note: string) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_notes/${noteId}`;
        return await axios.put(uri, { note }, this.config(sessionToken));
    }

    cancelInvoice = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number, payload: any) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_cancel`;
        let response = await axios.post(uri, payload, this.config(sessionToken));
        return response;
    }

    addPayment = async (sessionToken: string | null, campusId: number, studentId: number, invoiceId: number, payload: any) => {
        let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/invoices/${invoiceId}/_addPayment`;
        const formData = new FormData();

        formData.append("paidAmount", payload.paidAmount);
        formData.append("paymentDate", payload.paymentDate);
        formData.append("paymentMethodId", payload.paymentMethodId);
        formData.append("accountId", payload.accountId);
        formData.append("reference", payload.reference || "");
        formData.append("notes", payload.notes || "");
        payload.attachedFiles.forEach((file: File, index: number) => {
            formData.append(`attachedFiles[${index}]`, file);
        });

        let response = await axios.post(uri, formData, this.config(sessionToken, true));
        return response;
    }
}